import { IYmaps } from './types';
import { getConfig } from '@cian/config/browser';

declare const window: Window & {
  ymaps: IYmaps;
};

export function insertScriptToLoadYmaps(): Promise<IYmaps> {
  return new Promise((resolve, reject) => {
    if (window.ymaps) {
      resolve(window.ymaps);

      return;
    }

    const scriptTag = window.document.createElement('script');

    function clean() {
      window.document.body.removeChild(scriptTag);
    }

    const config = getConfig();
    const rsApiKey = config.getStrict<string>('builders.YandexApiKey');
    scriptTag.src = `https://enterprise.api-maps.yandex.ru/2.1/?apikey=${rsApiKey}&lang=ru-RU&load=Map`;
    scriptTag.async = true;
    scriptTag.defer = true;
    scriptTag.onload = () => {
      window.ymaps.ready(() => {
        resolve(window.ymaps);
        clean();
      });
    };
    scriptTag.onerror = () => {
      reject(new Error('Unable to load Yandex Maps API'));
      clean();
    };
    window.document.body.appendChild(scriptTag);
  });
}
